import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateCustomerContactController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CountryService from "../../../Setup/controller/CountryController/CountryController";
import CustomerService from "../../../Customer/Controller/CustomerController";
import CustomerSiteService from "../../../Customer/Controller/CustomerSiteController";
import CustomerContactService from "../../Controller/CustomerContactController";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import HelpSite from "../../../Common/HelpLink";
import Website from "../../../Common/website";
import TitleService from "../../../Setup/controller/TitleController/TitleController";
import SendEmail from "../../../Common/SendEmail";
import JobRoleService from "../../../Setup/controller/JobRoleController/JobRoleController";
import LeadUserDefineFieldsSection from '../../../Lead/Views/LeadForms/LeadUserDefineFieldsSection';
import JobUserDefineService from "../../../Jobs/Controller/UserDefineJobController";
import { handleSubmit as handleUserDefineSubmit } from "../../../Jobs/Controller/CreateUserDefineController";

import CompanySetupController from "../../../SuperAdmin/Controller/Client/SACompanyListController";
import JasperReportService from '../../../Dashboard/Controller/JasperReportController';
import axiosInstance from '../../../../config/axiosInstance';
import BASE_URL from "../../../../config/config";
import Draggable from 'react-draggable';
import CreateContactNotesModal from './CreateContactNotesModal';
import CustomerHistoryService from "../../Controller/CustomerHistoryController";
import ReportService from "../../../Setup/controller/ReportController/ReportController";
import Swal from 'sweetalert2';
import TermsConditionService from "../../../Setup/controller/TermsConditionController/TermsConditionController";
import { PDFDocument } from "pdf-lib";
import { getMergedPDFBlob } from '../../../Common/ReportPDFService';
function CreateCustomerContact({ ClientCompanyID, CustomerSites, ClientContactID, onClose, onNext, onPrevious, isLock, JobTab }) {
    const { theme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [CountryList, setCountries] = useState([]);
    const [CustomerList, setCustomer] = useState([]);
    const [CustomerSiteList, setCustomerSite] = useState([]);
    const [TitleList, setTitles] = useState([]);
    const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
    const [Email, setEmail] = useState();
    const [isChanged, setIsChanged] = useState(false);
    const [formData, setFormData] = useState({
        ClientBranchID: '', ContactTypeID: '', Title: 'Mr', FirstName: '', SurName: '',
        Email: '', ClientCompanyID: ClientCompanyID, Country: "184", JobRoleID: '0'
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const [jobRoleList, setJobRoles] = useState([]);
    const [KeyNameList, setKeyNames] = useState([]);
    const [phone, setPhone] = useState();
    const [mobile, setMobile] = useState();
    const fetchKeyNames = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const KeyNames = await JobUserDefineService.GetJobUserDefine(redirectCallback, ClientContactID, 15);
            setKeyNames(KeyNames || []);

            // Initialize form data with vc_Value if available
            const initialFormData = {};
            KeyNames.forEach(keyItem => {
                if (keyItem.vc_Value) {
                    initialFormData[keyItem.vc_Name] = keyItem.vc_Value;
                }
            });

            // ✅ Merge into existing formData instead of replacing it
            setFormData(prev => ({
                ...prev,
                ...initialFormData
            }));
        } catch (error) {
            console.error('Error fetching Key Names:', error);
        }
    };
    const handleFieldChange = (event, keyItem = null) => {
        const { name, value } = event.target;
        setIsChanged(true);
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleIntegerChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleDecimalChange = (e) => {
        const { name, value } = e.target;
        if (/^\d*\.?\d*$/.test(value)) {
            setFormData(prevData => ({ ...prevData, [name]: value }));
        }
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setFormData(prevData => ({ ...prevData, [name]: files[0] }));
    };
    const fetchCountries = async () => {
        try {
            const listOfCountries = await CountryService.GetAllCountries();
            setCountries(listOfCountries);
        } catch (error) {
            console.error('Error fetching countries:', error);
        }
    };
    const fetchJobRole = async () => {
        try {
            const list = await JobRoleService.GetAllJobRole();
            setJobRoles(list);

        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchCustomers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const listOfCustomers = await CustomerService.GetAllCustomers(redirectCallback);
            setCustomer(listOfCustomers);
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
    };
    const fetchTitle = async () => {
        try {
            const listOfTitles = await TitleService.GetAllTitle();
            setTitles(listOfTitles);
            if (listOfTitles.length > 0) {
                setFormData(formData => ({
                    ...formData,
                    Title: listOfTitles[0].Title, // Assuming IssuePriorityID is the field name
                }));
            }
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };
    const fetchCustomerSites = async (customerID, IsEdit) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const listOfCustomerSites = await CustomerSiteService.GetAllCustomersSites(redirectCallback, customerID);
            setCustomerSite(listOfCustomerSites);
            if (IsEdit == "0") {

                if (listOfCustomerSites.length > 0) {
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        ClientBranchID: listOfCustomerSites[0].ClientBranchID
                    }));
                }
            }
        } catch (error) {
            console.error('Error fetching customer sites:', error);
        }
    };

    const fetchCustomerContactDetail = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            setIsChanged(false);
            if (ClientContactID > 0) {
                const CustomerDetail = await CustomerContactService.GetCustomerContactByID(redirectCallback, ClientContactID);
                setFormData(CustomerDetail[0]);
                setPhone(CustomerDetail[0].Phone);
                setMobile(CustomerDetail[0].Mobile);
                fetchCustomerSites(CustomerDetail[0].ClientCompanyID, "1");
            }
        } catch (error) {
            console.error('Error fetching discounts:', error);
        }
    };

    useEffect(() => {
        fetchCountries();
        fetchCustomers();
        fetchTitle();
        fetchJobRole();
        if (ClientContactID > 0) {
            fetchCustomerContactDetail();
            fetchKeyNames();
            //  fetchCommunication();
        }
    }, [ClientContactID]);

    useEffect(() => {
        if (ClientCompanyID > 0) {
            fetchCustomerSites(ClientCompanyID, "0");
        }
    }, [ClientCompanyID]);

    useEffect(() => {
        if (ClientContactID > 0 && CustomerSiteList.length > 0) {
            const contactDetail = CustomerSiteList.find(site => site.ClientBranchID === formData.ClientBranchID);
            if (contactDetail) {
                setFormData(prevFormData => ({
                    ...prevFormData,
                    ClientBranchID: contactDetail.ClientBranchID,
                }));
            }
        }
    }, [CustomerSiteList]);

    const handleCustomerChange = async (event) => {
        const { value } = event.target;
        setFormData({
            ...formData,
            ClientCompanyID: value,
            ClientBranchID: 0,
        });

        if (ClientCompanyID === 0) {
            fetchCustomerSites(value, "0");
        }
    };


    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    const handleFormSubmit = async (event) => {
        event.preventDefault(); // Prevent default form submission
        if (ClientContactID > 0 && !isChanged) {
            return;
        }
        formData.ContactTypeID = 0;
        if (formData.ClientContactID == null || formData.ClientContactID == "undefined") {
            formData.ID = 0;
        } else {
            formData.ID = formData.ClientContactID;
        }
        const redirectUserList = () => {
            navigate('/CustomerList?saved=true');
        };
        const formDataWithParts = {
            formData: formData,
            tableData: CommunicationList,

        };
        const message = await handleSubmit(event, formDataWithParts, setFormData, setErrors);
        await fetchCustomerContactDetail();
        if (message && message.message == "Data saved successfully") {
            setIsChanged(false);
            localStorage.setItem('HasRecordUpdated', "1");
            setShowSuccessMessage(true);
            await handleUserDefineSubmit({
                JobID: ClientContactID,
                fields: KeyNameList.map(key => ({
                    PK_KeyName_ID: key.PK_KeyName_ID,
                    value: formData[key.vc_Name] || ''
                }))
            });
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowSuccessMessage(false);
            }, 5000);
            onClose();
            //  redirectUserList();

        } else {
            setShowErrorMessage(true);
            window.scrollTo({ top: 0, behavior: 'smooth' });
            setTimeout(() => {
                setShowErrorMessage(false);
            }, 5000);
        }
    };
    const handleEmailClick = async (event, email) => {
        event.stopPropagation();
        setEmail(email)
        setIsEmailModalOpen(true);
    };
    const handleCloseEmailModal = async () => {
        setIsEmailModalOpen(false);
    };

    const [imageData, setImageData] = useState(null);
    const [reportLink, setReportLink] = useState('');
    const [reportTitle, setReportTitle] = useState('');
    const [error, setError] = useState(null);
    const [pdfUrl, setPdfUrl] = useState(null); // State to store the PDF URL
    const [showPdfModal, setShowPdfModal] = useState(false);
    useEffect(() => {
        // Load image as base64
        const loadImage = async () => {
            try {
                const ClientID = localStorage.getItem('CompanyID');
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const companySetup = await CompanySetupController.GetCompanyByID(redirectCallback, ClientID);
                const fileName = companySetup[0]?.FileName; // Check if fileName exists

                let imageUrl;
                if (!fileName) {
                    // Use fallback image if fileName is null or empty
                    imageUrl = 'assets/img/resources/trent.PNG';
                } else {
                    imageUrl = `${BASE_URL}/uploads/${ClientID}/Admin/CompanySetup/${fileName}`;
                }
                debugger;
                console.log("Fetching image from:", imageUrl); // Debugging

                const response = await fetch(imageUrl, {
                    method: 'GET',
                    mode: 'cors', // Ensure CORS mode
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });

                if (!response.ok) {
                    console.error(`Error fetching image: ${response.statusText}`);
                    return;
                }

                const blob = await response.blob();
                const reader = new FileReader();
                reader.onloadend = () => {
                    setImageData(reader.result); // Convert to base64
                };
                reader.readAsDataURL(blob);
            } catch (error) {
                console.error("Error loading image:", error);
            }
        };

        loadImage();
    }, []);


    const generatePDF = async (event) => {
        event.stopPropagation();

        try {


            const blob = await getMergedPDFBlob({
                moduleId: "15",
                navigate,
                currentInputValues: {
                    ID: ClientContactID
                },
                defaultReportID: 120,
                setReportLink,
                setReportTitle,
                setError
            });

            const finalUrl = URL.createObjectURL(blob);

            setPdfUrl(finalUrl);
            setShowPdfModal(true);



        } catch (err) {
            console.error(err);
        }
    };


    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    const tableRef = useRef();
    const [loading, setLoading] = useState(true);
    const [CommunicationList, setCommunicationData] = useState([]);
    const [currentCommunicationHistory, setCurrentCommunicationHistory] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };
    const truncateText = (text, maxLength = 150) => {
        if (!text) return '';  // Return empty string if text is null or empty
        return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
    };
    const handleDeleteClick = async (event, ID) => {
        event.stopPropagation(); // Prevent the row click event

        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const redirectCallback = () => {
                        navigate('/'); // Redirect to the login page
                    };
                    await CustomerHistoryService.DeleteCustomerHistory(ID, redirectCallback)
                    // fetchCommunication();
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });
    };
    const handleEditClick = (data, index) => {

        setCurrentCommunicationHistory(data, index);
        setIsModalOpen(true);
    };
    const fetchCommunication = async () => {
        try {
            setCommunicationData([]);
            setLoading(true);
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await CustomerHistoryService.CustomerHistoryByContactID(redirectCallback, ClientContactID);

            const selectedPartsData = data.map(detail => {
                const formattedDate = detail.dt_Created ? detail.dt_Created.slice(0, 10) : '';
                const AppointmentDate = detail.AppointmentDate ? detail.AppointmentDate.slice(0, 10) : '';
                const DueDate = detail.DueDate ? detail.DueDate.slice(0, 10) : '';
                const AppointmentEndDate = detail.AppointmentEndDate ? detail.AppointmentEndDate.slice(0, 10) : '';

                return {
                    ID: detail.PK_ContactHistory_ID,
                    snt_CommunicationType: detail.snt_CommunicationType.toString(),
                    vc_Description: detail.vc_Description,
                    dt_Created: formattedDate,
                    vc_Subject: detail.vc_Subject,
                    vc_From: detail.vc_From,
                    vc_To: detail.vc_To,
                    vc_CC: detail.vc_CC,
                    AppointmentDate: AppointmentDate,
                    StartTime: detail.StartTime,
                    Completed: detail.Completed,
                    DueDate: DueDate,
                    DueTime: detail.DueTime,
                    DisplayName: detail.DisplayName,
                    AppointmentEndDate: AppointmentEndDate,
                    EndTime: detail.EndTime,
                    UserTask: detail.UserTask,
                    AssignUserID: detail.AssignUserID,
                    StatusText: detail.StatusText,
                    Status: detail.Status,
                    EmailStatus: detail.EmailStatus,
                    IsEmailSend: detail.IsEmailSend,
                    Title: detail.Title,
                    FirstName: detail.FirstName,
                    SurName: detail.SurName,
                    FK_ClientContact_ID: detail.FK_ClientContact_ID,

                    // Map other fields as needed
                };
            });

            setCommunicationData(selectedPartsData);
        } catch (error) {
            console.error('Error fetching Contacts:', error);
        } finally {
            setLoading(false); // Stop loading after fetching
        }
    };
    const handleCommunicationSubmit = (CommunicationData) => {

        setIsChanged(true);
        if (Array.isArray(CommunicationData)) {
            const existingEntriesMap = new Map(CommunicationList.map(entry => [entry.ID, entry]));
            const updatedEntries = [];
            const newEntries = [];

            CommunicationData.forEach(data => {
                if (data.ID > 0) {
                    // Update existing entry if present
                    if (existingEntriesMap.has(data.ID)) {
                        updatedEntries.push(data);
                    } else {
                        // If an entry has a valid ID but doesn't exist, add it as new
                        newEntries.push(data);
                    }
                } else {
                    // Generate a unique EngineerTimeID for new entries
                    const newID = CommunicationList.length > 0
                        ? Math.max(...CommunicationList.map(row => row.ID)) + 1
                        : 1;
                    data.ID = 0;
                    newEntries.push(data);
                }
            });

            const finalTableData = [
                ...CommunicationList.filter(entry => !updatedEntries.some(updated => updated.ID === entry.ID)),
                ...updatedEntries,
                ...newEntries
            ];
            setCommunicationData(finalTableData);

            setIsModalOpen(false);
        }

    };
    const handleCloseModal = async () => {
        setIsChanged(true);
        if (ClientContactID > 0) {
            // await fetchCommunication();
        }
        setIsModalOpen(false);

    };

    const handleAddCommunicationHistory = () => {
        setCurrentCommunicationHistory(null);
        setIsModalOpen(true);
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                {showSuccessMessage && (
                    <div className="alert alert-success bg-success text-light border-0 alert-dismissible fade show" role="alert">
                        Data saved successfully.
                    </div>
                )}
                {showErrorMessage && (
                    <div className="alert alert-danger bg-danger text-light border-0 alert-dismissible fade show" role="alert">
                        Validation Error.
                    </div>
                )}
                <div className="row mb-3" style={{ "marginLeft": "2px" }}>
                    <div className="col-xl-12" style={{ "textAlign": "right" }}>

                    </div>
                </div>
                <div style={{ maxHeight: "650px", overflowY: "auto", overflowX: "hidden" }}>
                    <table style={{ width: "100%" }}>
                        <tbody>
                            <tr>
                                <td><label htmlFor="Title" style={{ float: "right" }}>Title &nbsp;&nbsp;</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <select name="Title" className="form-control select-title" value={formData.Title} onChange={handleFieldChange}
                                        >
                                            <option value="0">Select Title</option>
                                            {TitleList.map((title) => (
                                                <option key={title.Title} value={title.Title}>
                                                    {title.Title}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.Title && <div style={{ color: 'red' }}>{errors.Title}</div>}
                                    </td>
                                        <td><label htmlFor="dec_Weight" style={{ float: "right" }}>Position &nbsp;&nbsp;</label></td>
                                        <td>
                                            <select name="JobRoleID" className='form-control' value={formData.JobRoleID} onChange={handleFieldChange}>
                                                <option value="0">Select Position</option>
                                                {jobRoleList.map((jobRole) => (
                                                    <option key={jobRole.ID} value={jobRole.ID}>
                                                        {jobRole.JobRole}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                                <td>
                                    <label htmlFor="CustomerID" style={{ float: "right" }}>Customer &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <select name="ClientCompanyID" className="form-control" value={formData.ClientCompanyID} onChange={handleCustomerChange} disabled={ClientCompanyID > '0'}>
                                        <option value="0">Select Customer</option>
                                        {CustomerList.map((customer) => (
                                            <option key={customer.ClientCompanyID} value={customer.ClientCompanyID}>
                                                {customer.CompanyName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.ClientCompanyID && <div style={{ color: 'red' }}>{errors.ClientCompanyID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="FirstName" style={{ float: "right" }}>Forename <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="FirstName" value={formData.FirstName} onChange={handleFieldChange} />
                                    {errors.FirstName && <div style={{ color: 'red' }}>{errors.FirstName}</div>}
                                </td>
                                <td><label htmlFor="ClientBranchID" style={{ float: "right" }}>Branch &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="ClientBranchID" className='form-control' value={formData.ClientBranchID} onChange={handleFieldChange}>
                                        <option value="0">Select Branch</option>
                                        {CustomerSiteList.map((site) => (
                                            <option key={site.ClientBranchID} value={site.ClientBranchID}>
                                                {site.BranchName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.ClientBranchID && <div style={{ color: 'red' }}>{errors.ClientBranchID}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="SurName" style={{ float: "right" }}>Surname <span style={{ "color": "red" }}>*</span></label></td>
                                <td>
                                    <input type="text" className="form-control" name="SurName" value={formData.SurName} onChange={handleFieldChange} />
                                    {errors.SurName && <div style={{ color: 'red' }}>{errors.SurName}</div>}
                                </td>
                                <td>
                                    <label htmlFor="Email" style={{ float: "right" }}>Email &nbsp;&nbsp;</label>
                                </td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="Email" value={formData.Email} onChange={handleFieldChange} />
                                        {errors.Email && <div style={{ color: 'red' }}>{errors.Email}</div>}

                                    </td>
                                        <td>
                                            {(ClientContactID > 0) && (formData.Email != "" && formData.Email != null && formData.Email != "undefined") && (

                                                <a href='#' onClick={(event) => handleEmailClick(event, formData.Email)}>
                                                    <img src="assets/img/resources/email-icon.png" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}>Address &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" placeholder={ClientContactID > 0 ? '' : 'Address 1'} className="form-control" name="Address1" value={formData.Address1} onChange={handleFieldChange} />
                                    {errors.Address1 && <div style={{ color: 'red' }}>{errors.Address1}</div>}
                                </td>
                                <td><label htmlFor="Phone" style={{ float: "right" }}>Telephone &nbsp;&nbsp;</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="Phone" value={formData.Phone} onChange={handleFieldChange} />
                                        {errors.Phone && <div style={{ color: 'red' }}>{errors.Phone}</div>}
                                    </td>
                                        <td>
                                            {(ClientContactID > 0) && (formData.Phone != "" && formData.Phone != null && formData.Phone != "undefined") && (
                                                <a href={`tel:${formData.Phone}`} onClick={(e) => e.stopPropagation()}>
                                                    <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>

                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}></label></td>
                                <td>
                                    <input type="text" placeholder={ClientContactID > 0 ? '' : 'Address 2'} className="form-control" name="Address2" value={formData.Address2} onChange={handleFieldChange} />
                                    {errors.Address2 && <div style={{ color: 'red' }}>{errors.Address2}</div>}
                                </td>
                                <td><label htmlFor="Mobile" style={{ float: "right" }}>Mobile &nbsp;&nbsp;</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="Mobile" value={formData.Mobile} onChange={handleFieldChange} />
                                        {errors.Mobile && <div style={{ color: 'red' }}>{errors.Mobile}</div>}
                                    </td>
                                        <td>
                                            {(ClientContactID > 0) && (formData.Mobile != "" && formData.Mobile != null && formData.Mobile != "undefined") && (
                                                <a href={`tel:${formData.Mobile}`} onClick={(e) => e.stopPropagation()}>
                                                    <img src="assets/img/resources/phone.jpeg" alt="Add icon" style={{ height: "22px" }} />
                                                </a>
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}></label></td>
                                <td>
                                    <input type="text" className="form-control" placeholder={ClientContactID > 0 ? '' : 'Address 3'} name="Address3" value={formData.Address3} onChange={handleFieldChange} />
                                    {errors.Address3 && <div style={{ color: 'red' }}>{errors.Address3}</div>}
                                </td>
                                <td><label htmlFor="Website" style={{ float: "right" }}>Website &nbsp;&nbsp;</label></td>
                                <td>
                                    <table style={{ width: "100%" }}><tr><td>
                                        <input type="text" className="form-control" name="Website" value={formData.Website} onChange={handleFieldChange} />
                                        {errors.Website && <div style={{ color: 'red' }}>{errors.Website}</div>}

                                    </td>
                                        <td>

                                            {(ClientContactID > 0) && (formData.Website != "" && formData.Website != null && formData.Website != "undefined") && (
                                                <Website webLink={formData.Website} />
                                            )}
                                        </td>
                                    </tr>
                                    </table>
                                </td>

                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}>City &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="City" value={formData.City} onChange={handleFieldChange} />
                                    {errors.City && <div style={{ color: 'red' }}>{errors.City}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}>Post Code &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="Postcode" value={formData.Postcode} onChange={handleFieldChange} />
                                    {errors.Postcode && <div style={{ color: 'red' }}>{errors.Postcode}</div>}
                                </td>
                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}>County &nbsp;&nbsp;</label></td>
                                <td>
                                    <input type="text" className="form-control" name="County" value={formData.County} onChange={handleFieldChange} />
                                    {errors.County && <div style={{ color: 'red' }}>{errors.County}</div>}
                                </td>

                            </tr>
                            <tr>
                                <td><label htmlFor="inputText" style={{ float: "right" }}>Country &nbsp;&nbsp;</label></td>
                                <td>
                                    <select name="Country" className='form-control' value={formData.Country} onChange={handleFieldChange}>
                                        <option value="0">Select Country</option>
                                        {CountryList.map((country) => (
                                            <option key={country.PK_Country_ID} value={country.PK_Country_ID}>
                                                {country.vc_CountryName}
                                            </option>
                                        ))}
                                    </select>
                                    {errors.Country && <div style={{ color: 'red' }}>{errors.Country}</div>}
                                </td>

                            </tr>
                            {KeyNameList.length > 0 && (
                                <>
                                    <LeadUserDefineFieldsSection
                                        KeyNameList={KeyNameList}
                                        formData={formData}
                                        errors={errors}
                                        handleInputChange={handleFieldChange}
                                        handleDecimalChange={handleDecimalChange}
                                        handleIntegerChange={handleIntegerChange}
                                        handleFileChange={handleFileChange}
                                    />
                                </>
                            )}
                        </tbody>
                    </table>

                    <div className="row" style={{ "marginLeft": "0px" }}>
                        <div className="col-sm-6">
                            <button type="button" style={{ background: "#2E7D32" }} className={`btn btn-secondary btn-sm ${isLock > 0 ? 'disabled' : ''}`}
                                disabled={isLock > 0} onClick={handleAddCommunicationHistory}>
                                <i className="icofont-plus" aria-hidden="true"></i> Add Comms</button>
                        </div>

                        <div className="col-sm-6">
                            <button onClick={() => onClose(isChanged)} type="button" className={`btn btn-danger`} style={{ float: "right", "marginLeft": "5px" }}>
                                <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                            </button>
                            <button type="submit" className={`btn btn-primary ${parseInt(isLock) > 0 || localStorage.getItem('LicenseExpired') == "1" ? 'disabled' : ''}`} disabled={parseInt(isLock) > 0} style={{ "float": "right", "marginLeft": "5px" }}>
                                <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  Save
                            </button>
                            <button style={{ "marginLeft": "5px", float: "right" }} type="button" className="btn btn-secondary" onClick={generatePDF}>
                                <img src="assets/img/resources/printer-icon.png" alt="Add icon" style={{ height: "10px" }} />  Print
                            </button>
                            {ClientCompanyID === 0 && (
                                <>
                                    <button type='button' className="btn btn-previous" style={{ float: "right", "marginLeft": "5px" }} onClick={() => onNext(isChanged)}>
                                        <img src="assets/img/resources/next-icon.png" alt="Add icon" style={{ height: "10px" }} />  Next
                                    </button>
                                    <button type='button' className="btn btn-previous" style={{ float: "right" }} onClick={() => onPrevious(isChanged)}>
                                        <img src="assets/img/resources/pevious-icon.png" alt="Add icon" style={{ height: "10px" }} />  Previous
                                    </button>
                                </>
                            )}

                        </div>
                    </div>
                </div>

            </form>
            {isEmailModalOpen && (
                <SendEmail onClose={handleCloseEmailModal} ToEmail={Email} Module="Customer" ModuleID={ClientContactID} />
            )}
            {showPdfModal && pdfUrl && (
                <div className="modal fade show d-block" tabIndex="-1">
                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}>
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">PDF Report</h5>
                                    <button type="button" className="close" onClick={() => setShowPdfModal(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <embed src={pdfUrl} type="application/pdf" width="100%" height="600px" />
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            )}
            {isModalOpen && (
                <CreateContactNotesModal
                    show={isModalOpen}
                    currentCommunicationHistory={currentCommunicationHistory}
                    onFormSubmit={handleCommunicationSubmit}
                    onClose={handleCloseModal}
                    data={formData}
                    ClientContactID={ClientContactID}
                    Phone={phone}
                    Mobile={mobile}
                    ToEmail={Email}
                />
            )}
        </div>
    );
}
export default CreateCustomerContact;